/**
 * "Does this record already exist?" — the check the create flow runs while the
 * user types the identifying field (CT-5525).
 *
 * Customers are identified by email and companies by domain. The answer carries
 * the matching records so the screen can offer to OPEN the existing one instead
 * of creating a duplicate. The server stays authoritative: `entityCreate` still
 * answers 409, this only saves the user from finding out at the last step.
 *
 * Real signature and snake_case body; only the transport is stubbed.
 */

import { validateApiResponse } from '../shared/utils/apiResponse.js';
import { request } from './mockTransport.js';

/** `{ exists, matches: [{ id, title, entityType }] }`; `matches` is always an array. */
export const mapApiExistsToUi = (raw = {}) => ({
  exists: Boolean(raw.exists),
  matches: (raw.matches ?? []).map((match) => ({
    id: match.entity_id ?? match.entityId ?? match.id ?? '',
    title: match.title ?? match.name ?? match.label ?? '',
    entityType: match.entity_type ?? match.entityType ?? null,
  })),
});

/**
 * @param {{ entityType: string, key: { email: string } | { domain: string } }} params
 * TODO(CT-5525 / backend): `POST /v0/profile/entities/exists` is assumed.
 */
export const checkEntityExists = async ({ entityType, key } = {}) => {
  const response = await request('/v0/profile/entities/exists', { entity_type: entityType, key });
  return validateApiResponse(response, 'Failed to check whether the record exists');
};
